import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'


const get = (search, order) =>
  axios({
    method: 'get',
    url: config.endpoints.nauta.bot_buttons + '?search=' + search,
    headers: getHeaders(true),
  })

const put = (processId, process) =>
  axios({
    method: 'put',
    url: config.endpoints.nauta.bot_buttons + '/' + processId,
    headers: getHeaders(true),
    data: process
  })

const post = (process) =>
  axios({
    method: 'post',
    url: config.endpoints.nauta.bot_buttons,
    headers: getHeaders(true),
    data: process,
  })

const remove = (processId) =>
  axios({
    method: 'delete',
    url: config.endpoints.nauta.bot_buttons + '/' + processId,
    headers: getHeaders(true),
  })

const launchProcess = (data) =>
  axios({
    method: 'post',
    url: config.endpoints.nauta.lauch_process,
    headers: getHeaders(true),
    data: data,
  })

export default {
  get,
  put,
  post,
  remove,
  launchProcess,
}